import { db } from "../index";

export interface UploadedIncidentResult {
  /** uploaded | partial | unavailable | failed */
  status: string;
  message?: string;
  /** Server time the result was written, for filtering out results of earlier requests. */
  createdMs?: number;
  storedFromTut?: number;
  storedToTut?: number;
}

/**
 * Listen for the device's reply to an audio slice request. scout-api writes one
 * document per incident; documents expire via a Firestore TTL policy after ~24h,
 * so a result from an earlier request may still exist when the listener attaches —
 * callers should filter on createdMs.
 *
 * Returns the unsubscribe function.
 */
export const listenForUploadedIncident = (
  organisationId: string,
  incidentId: string,
  callback: (result: UploadedIncidentResult) => void,
) => {
  return db
    .doc("commander")
    .collection("organisations")
    .doc(organisationId)
    .collection("uploadedIncidents")
    .doc(incidentId)
    .onSnapshot((snapshot) => {
      const data = snapshot.data();
      if (!data || !data.status) {
        return;
      }
      callback({
        status: data.status,
        message: data.message ? data.message : undefined,
        createdMs: data.created ? data.created.toMillis() : undefined,
        storedFromTut: data.storedFromTut ? data.storedFromTut : undefined,
        storedToTut: data.storedToTut ? data.storedToTut : undefined,
      });
    });
};
